"use client";

import { Fragment } from "react";

function getIconUrl(tech: string): string {
    const map: Record<string, string> = {
        "React": "react",
        "Next.js": "next-js",
        "TypeScript": "typescript",
        "Node.js": "node-js",
        "Python": "python",
        "Go (Golang)": "go-golang",
        "Rust": "rust",
        "FastAPI": "fastapi",
        "Express": "express",
        "Django": "django",
        "GraphQL": "graphql",
        "Bun": "bun",
        "Deno": "deno",
        "NestJS": "nestjs",
        "Prisma": "prisma",
        "Strapi": "strapi",
        "Payload CMS": "payload-cms",
        "PostgreSQL": "postgresql",
        "MongoDB": "mongodb",
        "Redis": "redis",
        "Vector DBs": "vector-dbs",
        "OpenAI API": "openai-api",
        "PyTorch": "pytorch",
        "LangChain": "langchain",
        "HuggingFace": "huggingface",
        "Gemini API": "gemini-api",
        "Claude": "claude",
        "AWS": "aws",
        "Google Cloud": "google-cloud",
        "Vercel": "vercel",
        "Docker": "docker",
        "Kubernetes": "kubernetes",
        "Terraform": "terraform",
        "GitHub Actions": "github-actions",
        "Prometheus": "prometheus",
        "Supabase": "supabase",
        "Firebase": "firebase",
        "Fly.io": "fly-io",
        "Svelte": "svelte",
        "Astro": "astro",
        "Vite": "vite",
        "Flutter": "flutter"
    };
    const slug = map[tech];
    return slug ? `/logos/${slug}.svg` : "";
}

export default function TechStack() {
    const stack = [
        "React", "Next.js", "TypeScript", "Node.js", "Python", "Bun", "Deno", "Go (Golang)", "Rust", "FastAPI", "Flutter", "Firebase", "Supabase", "AWS", "Google Cloud", "Docker", "Kubernetes", "TailwindCSS", "PostgreSQL", "MongoDB", "GraphQL", "Svelte", "Astro", "Vite", "Gemini API", "Claude", "Strapi", "Payload CMS"
    ];

    return (
        <section className="py-12 border-y border-black bg-black text-white overflow-hidden">
            <div className="flex whitespace-nowrap overflow-hidden">
                <div
                    className="animate-marquee flex gap-12 font-mono text-xl uppercase tracking-widest px-6 items-center"
                    style={{ animationDuration: "45s" }}
                >
                    {stack.map((tech, i) => {
                        const iconUrl = getIconUrl(tech);
                        return (
                            <Fragment key={i}>
                                <span className="flex items-center space-x-4">
                                    {iconUrl && (
                                        <img src={iconUrl} alt={tech} className="w-6 h-6 object-contain shrink-0" />
                                    )}
                                    <span>{tech}</span>
                                </span>
                                <span className="w-2 h-2 bg-primary rounded-full shrink-0"></span>
                            </Fragment>
                        );
                    })}
                    {stack.map((tech, i) => {
                        const iconUrl = getIconUrl(tech);
                        return (
                            <Fragment key={`dup-${i}`}>
                                <span className="flex items-center space-x-4">
                                    {iconUrl && (
                                        <img src={iconUrl} alt={tech} className="w-6 h-6 object-contain shrink-0" />
                                    )}
                                    <span>{tech}</span>
                                </span>
                                <span className="w-2 h-2 bg-primary rounded-full shrink-0"></span>
                            </Fragment>
                        );
                    })}
                </div>
            </div>
        </section>
    );
}

